import styled from "styled-components";

import { clamp } from "@styles/utils/conversion.style";
import { colors } from "@styles/vars/colors.style";
import { mq } from '@styles/vars/media-queries.style'

export const ModelInfoMain = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background: ${colors.charcoal};
  color: ${colors.white};

  @media (max-width: 1023px) {
    min-height: auto;
    padding: 6rem 0;
    overflow: visible;
  }
`;

export const ModelInfoBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image: ${({ $backgroundUrl }) =>
    $backgroundUrl
      ? `url(${$backgroundUrl})`
      : "none"};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ModelInfoOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    90deg,
    rgba(30, 32, 40, 0.85),
    rgba(30, 32, 40, 0.55)
  );
`;

export const ModelInfoWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: auto;
  }
`;

export const ModelInfoLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;

  ${clamp("margin-top", 30, 80)};
  ${clamp("font-size", 32, 48)};

  color: ${colors.pastelGreen};
  font-family: Signifier;

  strong {
    font-family: National2;
    font-weight: 900;
  }

  @media (max-width: 1023px) {
    padding-top: 0;
    margin-bottom: 4rem;
  }
`;

export const ModelInfoBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1023px) {
    width: 100%;
    padding-left: 0;
  }
`;

export const ModelInfoTitle = styled.div`
  ${clamp("margin-top", 30, 180)};

  margin-bottom: clamp(2rem, 4vw, 5rem);

  ${mq.tabletL} {
    padding-left: 80px;
  }
  

  p {
    ${clamp("font-size", 42, 92)};

    font-family: Signifier;

    strong {
      font-family: National2;
      font-weight: 900;
    }
  }

  svg {
    width: 220px;
  }

  @media (max-width: 1023px) {
    margin-bottom: 2rem;

    svg {
      width: 150px;
    }
  }
`;

export const ModelInfoContent = styled.div`
  --line-progress: 1;

  position: relative;
  padding-left: 80px;

  ${clamp("padding-top", 40, 80)};
  ${clamp("padding-bottom", 40, 80)};
  ${clamp("font-size", 16, 24)};


  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 1px;
    background: ${colors.white};
    transform: scaleY(var(--line-progress));
    transform-origin: top center;
    will-change: transform;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
  }

  @media (max-width: 1023px) {
    --line-progress: 1;

    max-width: 100%;
    padding-left: 1.5rem;
  }
`;